import React, { useState } from 'react';
import Close from '../../UI/Icons/Close';
import './CartLineItem.scss';
import Button from '../../@redantler/redantler-npm-button-react';
import { formatMoney } from '@shopify/theme-currency';
import CartQuantity from '../CartQuantity/CartQuantity';
import { COLORS } from '../../../constants/colors';
import Loader from '../../UI/Icons/Loader/Loader';

/**
 * Displays a line item inside of the cart
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const CartLineItem = ({
  title,
  image = {},
  price,
  discounted_price,
  quantity,
  id,
  url,
  removeFromCart,
  updateCart,
  format,
}) => {
  const [fetching, setFetching] = useState(false);

  const removeAction = async () => {
    setFetching(true);
    await removeFromCart(removeProperties)
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  const removeProperties = {
    quantity: 0,
    id: id,
  };

  const imgSource = image?.url || image; // Safeguard for there not being any images uploaded for the product
  const formattedPrice = formatMoney(price, format);

  /**
   * Wrap the data in an anchor tag
   * @param content
   * @param url
   */
  const withLink = (url, content) => {
    return (
      <a href={url} className="c-cart-line-item__link">
        {content}
      </a>
    );
  };

  return (
    <div className="c-cart-line-item background-color-white">
      <div className="c-cart-line-item__product-img-wrapper background-color-gray">
        <img className="c-cart-line-item__product-img" src={imgSource} alt={image?.alt || ''} />
      </div>
      <div className="c-cart-line-item__content">
        <div className="c-cart-line-item__content-top">
          {withLink(
            url,
            <h4 className="c-cart-line-item__product-title h4-roobert color-black">{title}</h4>,
          )}
          <span className="c-cart-line-item__product-price tag color-black">
            {formatMoney(discounted_price, format)}
          </span>
          {discounted_price !== price && (
            <span className="c-cart-line-item__product-original-price tag color-black">
              {formatMoney(price, format)}
            </span>
          )}
        </div>
        <div className="c-cart-line-item__content-bottom">
          <div className="c-cart-line-item__quantity">
            <CartQuantity
              counter={quantity}
              handleIncrementClick={() => updateCart({ [id]: Number(++quantity) })}
              handleDecrementClick={() => updateCart({ [id]: Number(--quantity) })}
            />
          </div>
        </div>
      </div>
      <div className="c-cart-line-item__remove-btn">
        <Button onClick={removeAction}>
          {fetching ? <Loader /> : <Close color={COLORS.black} />}
        </Button>
      </div>
    </div>
  );
};

export default CartLineItem;
